import styled, { css } from 'styled-components';

export const AccordionItemWrapper = styled.div``;

export const ChevronContainer = styled.div`
  transition: 0.2s ease-out;
  transform-origin: center;
  opacity: 0.6;
`;

export const AccordionItemContainer = styled.div<{ $selected?: boolean }>`
  overflow: clip;
  max-width: 100%;
  ${({ theme, $selected }) =>
    $selected &&
    css`
      ${ChevronContainer} {
        transform: rotate(180deg);
        opacity: 1;
      }
    `}
`;

export const AccordionItemTriggerContainer = styled.div<{
  $disabled?: boolean;
}>`
  padding: 24px 0;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  ${({ $disabled }) =>
    $disabled &&
    css`
      pointer-events: none;
      opacity: 0.5;
    `}
`;

export const TriggerLabel = styled.div`
  margin-right: auto;
`;

export const ContentContainer = styled.div`
  padding: 0 0 12px 0;
  min-height: max-content;
  height: 100%;
`;

export const ContentWrapper = styled.div`
  overflow: clip;
`;
